// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__FXp9g","window":"styles_window__8BMiy","title":"styles_title__W4HHz","group":"styles_group__x7O3L","input":"styles_input__Dw+lz","btn":"styles_btn__q+noD"};